<div class="qrCodeContainer" *ngIf="currentNews" [@fadeZoom]="animationStateIn ? 'in':'out'">
    <div class="text">
        <p [innerHTML]="'NEWS.QR_CODE_VIDEO' | translate"></p>
    </div>
    <div class="qrCodeBox">
        <div class="qrCodePanel">
            <div class="border">
                <qrcode class="qrCode" [qrdata]="getUrl(currentNews.url)" [width]="qrCodeSize" [margin]="0" [colorDark]="'#ffffff'"
                [colorLight]="'#ffffff00'" [errorCorrectionLevel]="'M'">
                </qrcode>
            </div>
        </div>
    </div>
</div>